import { motion } from "framer-motion";
import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Anna Jhulya",
    text: "Foi maravilhosa, a mão é super levinha, passou rapidinho, não doeu nadinha pra furar. Furei a língua.",
    when: "Há 2 semanas",
  },
  {
    name: "Letícia de Paula",
    text: "Excelente atendimento e prestatividade! Recomendo de olhos fechados, pois sou cliente há mais de vinte anos!",
    when: "Há 7 semanas",
  },
  {
    name: "Beatriz Eugenio",
    text: "Furei o conch em outro lugar e não cicatrizava. Vim no Diggy, cuidaram, me deram as dicas certas — cicatrizou e nem fez granuloma.",
    when: "Há 7 semanas",
  },
  {
    name: "Eloisa Carvalho",
    text: "Fiz o piercing no umbigo. A profissional foi muito atenciosa, simpática e me deixou super confortável. Cuidadosa e profissional.",
    when: "Há 9 semanas",
  },
  {
    name: "Beatriz Del Carmen",
    text: "Lugar limpo, o pessoal é muito gentil. Todos os piercings que eu fiz lá cicatrizaram muito bem.",
    when: "Há 20 semanas",
  },
];

const Stars = () => (
  <div className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={14} className="text-[#E60000]" fill="#E60000" />
    ))}
  </div>
);

export const Reviews = () => (
  <section className="bg-[#0A0A0A] py-24 lg:py-32 px-6 border-t border-white/10" data-testid="reviews-section">
    <div className="max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-14"
      >
        <div>
          <p className="text-xs tracking-[0.3em] font-bold text-[#E60000] mb-3">AVALIAÇÕES DO GOOGLE</p>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white leading-none">
            Quem passou aqui, <span className="italic text-[#E60000]">conta.</span>
          </h2>
        </div>
        <div className="flex items-center gap-3" data-testid="reviews-score">
          <span className="font-display font-black text-5xl text-white">5.0</span>
          <Stars />
        </div>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <motion.blockquote
            key={r.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className={`bg-[#171717] border border-white/10 p-8 flex flex-col gap-5 hover:border-[#E60000]/50 transition-colors duration-500 ${i === 1 ? "lg:mt-10" : ""} ${i === 4 ? "lg:mt-10" : ""}`}
            data-testid={`review-card-${i}`}
          >
            <Stars />
            <p className="text-base font-light leading-relaxed text-white/80 flex-1">"{r.text}"</p>
            <footer className="flex items-center justify-between border-t border-white/10 pt-4">
              <span className="text-sm font-bold text-white">{r.name}</span>
              <span className="text-[10px] tracking-[0.2em] text-white/40">{r.when.toUpperCase()}</span>
            </footer>
          </motion.blockquote>
        ))}
      </div>
    </div>
  </section>
);
